import { FiUser, FiBriefcase, FiEdit2, FiTrash2 } from "react-icons/fi"

export default function SavedApplicantBox({
  applicant,
  onEdit,
  onDelete,
}: {
  applicant: any
  onEdit?: () => void
  onDelete: () => void
}) {
  const isEuipoPerson =
    !!applicant.euipoPersonIdentifier &&
    (!applicant.address?.street || !applicant.address?.postalCode)

  const isEuipo = !!applicant.euipoPersonIdentifier
  const isLegal = applicant.type === "legal"

  const displayName = isLegal
    ? applicant.legalName
    : `${applicant.firstName ?? ""} ${applicant.lastName ?? ""}`.trim()

  const address = applicant.address || {}
  const Icon = isLegal ? FiBriefcase : FiUser

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3.5 shadow-sm">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#fdecd8] text-[#b5670a]">
          <Icon size={18} />
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
              Applicant
            </span>

            {isEuipo && (
              <span className="rounded-full bg-[#fdecd8] px-2 py-0.5 text-[10px] font-medium text-[#b5670a]">
                From EUIPO
              </span>
            )}
          </div>

          <p className="mt-0.5 truncate text-sm font-medium text-gray-800">
            {displayName || "Applicant"}
          </p>

          {applicant.euipoPersonIdentifier && (
            <p className="truncate text-xs text-gray-400">
              ID: {applicant.euipoPersonIdentifier}
            </p>
          )}

          <p className="truncate text-xs text-gray-600">
            {address.city ?? "-"}, {address.country ?? "-"}
          </p>

          {!isEuipoPerson && address.street && (
            <p className="truncate text-xs text-gray-600">{address.street}</p>
          )}

          <div className="mt-2.5 flex gap-4 border-t border-gray-100 pt-2.5">
            {!isEuipoPerson && onEdit && (
              <button
                type="button"
                onClick={onEdit}
                className="inline-flex items-center gap-1 text-xs font-medium text-dantzBlue hover:underline"
              >
                <FiEdit2 size={13} /> Edit
              </button>
            )}

            <button
              type="button"
              onClick={onDelete}
              className="inline-flex items-center gap-1 text-xs font-medium text-red-600 hover:underline"
            >
              <FiTrash2 size={13} /> Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
